export default __webpack_public_path__ + "static/media/payment1.3e2766f9.webp";